import { Component, OnInit } from '@angular/core';
import {OauthService} from "./oauth.service";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";


export class AcsOutComponent implements OnInit {

  acsOutUrl : SafeResourceUrl = null;

  constructor(private oauth : OauthService, private sanitizer : DomSanitizer) {
    let str : string = `${this.oauth.getLogoutServerUrl()}?client_id=${this.oauth.clientId}&target=cloud-vspvision`;
    this.acsOutUrl = this.sanitizer.bypassSecurityTrustResourceUrl(str);

  }

  ngOnInit() {
  }


static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'app-acs-out',
  template: `<iframe id="acs-out"
                     [src]="acsOutUrl"
                     style="display: none;">
  </iframe>`,
  styles: [],
  inputs:["logout"]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: OauthService, },
{type: DomSanitizer, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}



// WEBPACK FOOTER //
// ../../src/lib/acs-out.component.ts